import * as XLSX from 'xlsx';

const validateName = (name: string) => {
  if((name + "").length > 2) {
    return true;
  }
  return false;
}

function alphabeticalSort(arr:string[]){
  let arrSorted = arr.sort((a,b) => {
    return a.trim().toLowerCase().localeCompare(b.trim().toLowerCase())
  })
  return arrSorted
}

function clearListeners(old_element: HTMLElement) {
  var new_element = old_element.cloneNode(true);
  old_element.parentNode?.replaceChild(new_element, old_element);
  return new_element;
}

async function parseMISExcel(file: File) {
  return file.arrayBuffer().then(data => {
    const workbook = XLSX.read(data, { type: 'array' });
    const metadata: any[] = []
    let compliancesArr: any = {}
    for (let sheetName of workbook.SheetNames) {
      const sheet = workbook.Sheets[sheetName];

      let rows: any[][] = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        defval: null
      })
      rows = rows.filter((row: any) => {
        let flagNull = true;
        for (let i = 0; i < row.length; i++) {
          if (row[i] != null) {
            flagNull = false
            break;
          }
        }
        return !flagNull;
      });
      let flagNull = true
      if(rows.length <= 0){
        console.log('skipping sheet1', sheetName, rows.length)
        continue;
      }
      for (let i = 0; i < rows[0].length; i++) {
        if (rows[0][i] != null) {
          flagNull = false
          break;
        }
      }
      if (flagNull) {
        rows = rows.slice(1)
      }
      if (rows.length <= 0 || rows[0][0] == null || rows[0][0].indexOf('NAME OF THE FACTORY') < 0) {
        console.log('skipping sheet', sheetName, rows.length, rows[0].length);
        continue;
      }
      
      // console.log('rows', rows);

      // ✅ Metadata extraction
      metadata.push({
        establishmentName: rows[0][1],
        address: rows[1][2],
        dateOfOpening: rows[2][2],
        industry: rows[3][2],
        hrName: rows[4][2],
        coordinator: rows[5][2],
        headCount: Number(rows[6][2])
      });

      console.log('months', rows[7])
      // let monthRow = rows[7]
      // ✅ Data starts from row index 10
      let dataRows = []
      dataRows = rows.slice(9);
      console.log('data rows', sheetName, dataRows.length, rows.length);
      compliancesArr[sheetName] = dataRows
        .filter(r => r[1] !== null && r[1] !== "Total")
        .map(row => ({
          labourCode: row[0] ?? "",
          act: row[1],
          documentName: row[2],
          forms: row[3],
          description: row[3],
          status: getStatus(row),
          periodicity: row[8],
          remarks: row[9]
        }));
    }
    // let compliances: any = {}
    // for(let compliance of compliancesArr){
    //   let id = compliance.no
    //   compliances[id] = compliance
    // }
    return { metadata, compliancesArr };
  });

  function getStatus(row: any[]): string {
    if (row[4] === 'ü') return 'Complied';
    if (row[5] === 'ü') return 'Delay/Partial Compliance';
    if (row[6] === 'ü') return 'Not Complied';
    if (row[7] === 'ü') return 'Not Applicable';
    return 'Unknown';
  }
  /* function getMonthlyStatus(row: any[], monthsRow: any[]): string {
    let retObj: any = {}
    for (let [indexRow, month] of monthsRow.entries()) {
      if (month != null) {
        if (row[indexRow] === 'ü') {
          retObj[month] = 'Complied'
        } else if (row[indexRow + 1] === 'ü') {
          retObj[month] = 'Delay/Partial Compliance'
        } else if (row[indexRow + 2] === 'ü') {
          retObj[month] = 'Not Complied'
        } else if (row[indexRow + 3] === 'ü') {
          retObj[month] = 'Not Applicable'
        }
      }
    }
    return retObj;
  }
  function getMonthlyPeriodicity(row: any[], monthsRow: any[]): string {
    let retObj: any = {}
    for (let [indexRow, month] of monthsRow.entries()) {
      if (month != null) {
        retObj[month] = row[indexRow + 4]
      }
    }
    return retObj;
  }
  function getMonthlyRemarks(row: any[], monthsRow: any[]): string {
    let retObj: any = {}
    for (let [indexRow, month] of monthsRow.entries()) {
      if (month != null) {
        retObj[month] = row[indexRow + 5]
      }
    }
    return retObj;
  } */
}

function readCookie(key: string) {
  let name = key + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

async function callApi(url: string, data: string, authorization: any) {

  return new Promise((resolve: any) => {

    const jsonData = JSON.stringify(data);
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", () => {
      if (xhr != null) {
        if (xhr.readyState === 4) {
          resolve(xhr);
        }
      }
    });
    xhr.open("POST", url);
    xhr.timeout = 1800000;
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    if (authorization != null) {
      xhr.setRequestHeader('Authorization', 'Basic ' + authorization);
    }
    xhr.send(jsonData);

    return xhr;

  })

}


async function callApiPresignedDelete(url: string) {

  return new Promise((resolve: any) => {

    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", () => {
      if (xhr != null) {
        if (xhr.readyState === 4) {
          resolve(xhr);
        }
      }
    });
    xhr.open("DELETE", url);
    xhr.timeout = 1800000;
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send(null);

    return xhr;

  })

}

async function callApiPresignedGet(url: string) {

  return new Promise((resolve: any) => {

    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", () => {
      if (xhr != null) {
        if (xhr.readyState === 4) {
          resolve(xhr);
        }
      }
    });
    xhr.open("GET", url);
    xhr.timeout = 1800000;
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send(null);

    return xhr;

  })

}

async function callApiPresigned(url: string, data: string) {

  return new Promise((resolve: any) => {

    const jsonData = JSON.stringify(data);
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", () => {
      if (xhr != null) {
        if (xhr.readyState === 4) {
          resolve(xhr);
        }
      }
    });
    xhr.open("PUT", url);
    xhr.timeout = 1800000;
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send(jsonData);

    return xhr;

  })

}

const exportFunctions = {
   validateName, alphabeticalSort, clearListeners, parseMISExcel, readCookie, callApi, callApiPresignedDelete, callApiPresignedGet, callApiPresigned
};

export default exportFunctions;